import Switch from "@components/Switch";
import Button from "@components/Button";
const radioGroups = [
  {
    question: "Seit wann benutzt du glo?",
    name: "q0",
    options: [
      { id: "q0-6-11", value: "6-11 months", label: "6-11 Monate" },
      { id: "q0-12-17", value: "12-17 months", label: "12-17 Monate" },
      { id: "q0-18+", value: "18+ months", label: "18+ Monate" },
    ],
  },
  {
    question:
      "Hast du seitdem mit dem Rauchen aufgehört oder deinen Zigarettenkonsum reduziert?",
    name: "q1",
    options: [
      { id: "q1-reduced-no", value: "no", label: "Nein" },
      { id: "q1-reduced-yes", value: "yes", label: "Ja" },
    ],
  },
  {
    question:
      "Sprichst du mit Rauchern in deinem Freundes- und Familienkreis über glo?",
    name: "q2",
    options: [
      { id: "q2-talk-no", value: "no", label: "Nein" },
      { id: "q2-talk-yes", value: "yes", label: "Ja" },
    ],
  },
];

const ContestForm = ({ answers }) => {
  const { q0, q1, q2, q3 } = answers?.content?.answers ?? {};
  const radioValues = [q0, q1, q2];
  return (
    <>
      <div className="contest-form completed">
        <h3 className="contest-title">Bitte teile uns mit...</h3>
        <div>
          <div className="radio-group">
            {radioGroups.map((group, groupIndex) => (
              <div
                tabIndex={groupIndex + 1}
                className="form-group"
                key={groupIndex}
              >
                <h3 className="form-question">{group.question} </h3>
                <div className="radio-group">
                  <div className={`radio-wrapper q${groupIndex}`}>
                    {group.options.map((option, i) => (
                      <div key={option.id}>
                        <input
                          readOnly
                          type="radio"
                          name={group.name}
                          id={option.id}
                          value={option.value}
                          checked={radioValues[groupIndex] === option.value}
                        />
                        <label htmlFor={option.id}>{option.label}</label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="form-group">
            <h3 className="form-question">Gib deine glo-Story ein! </h3>

            <textarea
              value={q3}
              readOnly
              maxLength={1000}
              placeholder="Was ist deine ganz persönliche Erfahrung mit glo?"
            />
          </div>
        </div>
        <div className="thank-you-message">
          <div className="thank-you-box">
            <h2>
              <strong>Danke,</strong> dass
              <br className="mobile" /> du deine glo
              <br className="mobile" />
              <span>
                -Story <br className="desktop" />
                mit
              </span>
              <br className="mobile" /> uns geteilt hast
            </h2>
            <p>
              Wir werden die Gewinner kontaktieren, sobald die&nbsp;Aktion
              beendet ist.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
export default ContestForm;
